import { OrderAsset } from '@features/orders/order-asset';
import { AssetType } from '@imcc/transport';
import { buildProduct } from './build-product';

export function buildOrderAssetProduct(orderAsset: OrderAsset) {
  const { sourceAsset, parameters } = orderAsset;

  if (sourceAsset.assetType === AssetType.Image) {
    return buildProduct({
      ...sourceAsset,
      orderedWidth: parameters.w,
      orderedHeight: parameters.h,
    });
  }

  return buildProduct(sourceAsset);
}
